export default [
  {
    title: 'Setup',
    icon: 'SettingsIcon',
    route: 'setup',
    children: [
      {
        title: 'Countries',
        route: 'setup-countries',
      },
      {
        title: 'Provinces',
        route: 'setup-provinces',
      },
      {
        title: 'Cities',
        route: 'setup-cities',
      },
      {
        title: 'Currency',
        route: 'setup-currency',
      },
      {
        title: 'Venue',
        route: 'setup-venues',
      },
      {
        title: 'Areas',
        route: 'setup-areas',
      },
    ],
  },
];
